import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-center items-center h-full min-h-[300px]"
}
const _hoisted_2 = {
  key: 1,
  class: "text-left text-md text-textPrimary"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " Não há nenhum pedido de excepcionalidade nessa vaga. Clique no botão abaixo caso deseje criar uma. ", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "font-bold text-sm text-textPrimary mb-2 text-start" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", { class: "border-gray-200 mb-3" }, null, -1)
const _hoisted_7 = { class: "grid grid-cols-2 gap-y-2 text-sm text-gray-800 mb-4 text-start" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Solicitante", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Data da solicitação", -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Aprovador", -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Data da aprovação", -1)
const _hoisted_14 = { class: "flex justify-between items-center" }
const _hoisted_15 = { class: "flex items-center gap-2" }
const _hoisted_16 = ["data-testid"]
const _hoisted_17 = {
  key: 0,
  class: "relative inline-flex w-full"
}

import { computed, ref, watch } from 'vue'
import { mdiLockOpenVariant } from '@mdi/js'
import { useErrorToast } from '@/composables/useErrorToast'

import BaseSidebar from '@/components/designSystem/Sidebar/BaseSidebar.vue'
import StationContextCard from '@/components/designSystem/Cards/StationContextCard.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import StatusBadge from '@/components/designSystem/Badges/StatusBadge.vue'

import ExceptionService from '@/Network/Services/DoctorStationException'
import {
  ExceptionStatusEnum,
  ExceptionActionType,
  DoctorStationExceptionRequest
} from '@/Network/Types/Requests/DoctorStationExceptionRequests'
import { formatDateToString } from '@/utils/date'
import SummaryExceptionalitySidebar from '@/components/designSystem/Sidebar/SummaryExceptionalitySidebar.vue'
import RequestExceptionalitySidebar from '@/components/designSystem/Sidebar/RequestExceptionalitySidebar.vue'
import { isReversalPending } from '@/utils/exception-reversal'
import ExceptionalityProgressTimeline from '@/modules/company/Approvals/AuditoriumExceptionalities/components/ExceptionalityProgressTimeline.vue'
import { mapApprovalToTimeline, mapReversalToTimeline } from '@/utils/approval-timeline-mapper'
import { usePermissionsStore } from '@/pinia-store/usePermissionsStore'
import { AuthorizationPermissions, AuthorizationResourcesAndSubjects } from '@/types/authorization'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import { POST_STATION_LOCK_BANNER_TEXT } from '@/modules/company/PostStation/constants'

export interface StationContextData {
  doctorName: string
  doctorCrm?: string
  scheduleName: string
  positionName: string
  shiftName?: string
  team?: string
  timeRange: string
  dutyType?: string
  value?: string
  formation?: string
  repassMode?: string
  proportionalityRule?: string
  breadcrumb?: string
  allocatedBy?: string
  startDetail?: string
  endDetail?: string
  timezone?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ExceptionalitiesSidebar',
  props: {
    isOpen: { type: Boolean },
    doctorStationId: {},
    scheduleId: {},
    stationContext: {},
    autoOpenExceptionId: {},
    postStationLocked: { type: Boolean, default: false }
  },
  emits: ["update:isOpen", "request-new", "action-completed-reload-data"],
  setup(__props: any, { emit }) {

const props = __props;

const { notifyError } = useErrorToast()
const exceptionService = new ExceptionService()
const permissionsStore = usePermissionsStore()
const { flags } = useFeatureFlags()





const canRequestExceptionality = computed(() => {
  if (!props.scheduleId) return false
  return permissionsStore.check({
    permission: AuthorizationPermissions.StationExceptionalitiesRequesting,
    resource: {
      objectType: AuthorizationResourcesAndSubjects.Schedule,
      objectId: props.scheduleId
    }
  })
})

const exceptionalities = ref<DoctorStationExceptionRequest[]>([])

const loading = ref(false)
const isActionSidebarOpen = ref(false)
const isReversalSidebarOpen = ref(false)
const exceptionIdSelected = ref<number | null>(null)
const currentActionType = ref<ExceptionActionType>(ExceptionActionType.VIEW)

const timelinePropsMap = computed(() => {
  const map = new Map<number, ReturnType<typeof mapApprovalToTimeline>>()
  for (const item of exceptionalities.value) {
    // Reversão pendente: a timeline relevante é a da reversão, não a da aprovação.
    if (isReversalPending(item, flags.enabledApprovalEngine) && item.reversalInstance) {
      map.set(item.id, mapReversalToTimeline(item.reversalInstance))
    } else if (flags.enabledApprovalEngine && item.approvalInstance) {
      map.set(
        item.id,
        mapApprovalToTimeline({
          approvalInstance: item.approvalInstance,
          requestDate: item.requestDate,
          requesterName: item.requester.name
        })
      )
    }
  }
  return map
})

// Fecha a Summary interna e limpa a seleção. Centralizado porque o fechamento
// chega por dois caminhos: (1) usuário fecha por aqui (setter de `modelValue`);
// (2) pai fecha por prop (`stationDetailsModal` escondido pelo consumidor via
// v-model). O caminho (2) dispara o watch de `isOpen`, que chama este mesmo
// método — sem isto, a `SummaryExceptionalitySidebar` interna ficaria aberta
// após o modal ser escondido, criando uma sidebar "fantasma" sobre a página.
function closeActionSidebar() {
  isActionSidebarOpen.value = false
  isReversalSidebarOpen.value = false
  exceptionIdSelected.value = null
  currentActionType.value = ExceptionActionType.VIEW
}

const modelValue = computed({
  get: () => props.isOpen,
  set: (value) => {
    emit('update:isOpen', value)
    if (!value) closeActionSidebar()
  }
})

async function handleViewRequest(item: DoctorStationExceptionRequest) {
  const { id: exceptionId, status } = item
  exceptionIdSelected.value = exceptionId

  // Reversão multi-etapa aguardando votos vem antes do roteamento por status:
  // o status continua "Aprovado" enquanto a reversão está pendente.
  if (isReversalPending(item, flags.enabledApprovalEngine) && props.scheduleId) {
    isActionSidebarOpen.value = false
    isReversalSidebarOpen.value = true
    return
  }

  if (status === ExceptionStatusEnum.AWAITING_APPROVAL) {
    currentActionType.value = ExceptionActionType.CANCEL
  } else if (status === ExceptionStatusEnum.APPROVED) {
    currentActionType.value = ExceptionActionType.REVERT
  } else if (
    status === ExceptionStatusEnum.REJECTED ||
    status === ExceptionStatusEnum.REVERTED ||
    status === ExceptionStatusEnum.CANCELED
  ) {
    currentActionType.value = ExceptionActionType.VIEW
  } else {
    currentActionType.value = ExceptionActionType.VIEW
    console.warn(`Status desconhecido ou não mapeado: ${status}. Exibindo em modo de visualização.`)
  }

  isActionSidebarOpen.value = true
}

function handleActionCompletedGeneric() {
  isActionSidebarOpen.value = false
  isReversalSidebarOpen.value = false
  fetchExceptionalities()
  emit('action-completed-reload-data')
}

function handleRequestNew() {
  emit('request-new')
}

async function fetchExceptionalities() {
  if (!props.doctorStationId) {
    exceptionalities.value = []
    return
  }

  loading.value = true
  exceptionalities.value = []
  try {
    const response = await exceptionService.getByDoctorStationId(props.doctorStationId)

    exceptionalities.value = response.data

    if (props.isOpen && props.autoOpenExceptionId) {
      const target = exceptionalities.value.find((e) => e.id === props.autoOpenExceptionId)
      if (target && isReversalPending(target, flags.enabledApprovalEngine) && props.scheduleId) {
        exceptionIdSelected.value = target.id
        isReversalSidebarOpen.value = true
      } else if (target) {
        exceptionIdSelected.value = target.id
        currentActionType.value = ExceptionActionType.VIEW
        isActionSidebarOpen.value = true
      }
    }
  } catch (err) {
    console.error('Erro ao buscar excepcionalidades', err)
    notifyError(err, 'Não foi possível carregar os pedidos de excepcionalidade')
    // Semântica implícita: falha no fetch implica estado vazio (array já foi
    // inicializado como `exceptionalities.value = []`). Sem isto, componente
    // exibiria o card genérico "Não há nenhum pedido..." (linha 15).
  } finally {
    loading.value = false
  }
}

watch(
  () => props.isOpen,
  (isOpen) => {
    if (isOpen) {
      fetchExceptionalities()
      return
    }
    // Fechamento programático pelo pai: sem isto a `SummaryExceptionalitySidebar`
    // interna (aberta pelo `autoOpenExceptionId`) ficava aberta, sozinha, sobre a
    // página — a sidebar "fantasma" após aprovar/recusar nas Aprovações.
    closeActionSidebar()
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BaseSidebar, {
      modelValue: modelValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
      title: "Excepcionalidades",
      description: "Veja os pedidos de excepcionalidade desta vaga ou solicite uma nova.",
      icon: _unref(mdiLockOpenVariant)
    }, _createSlots({
      footer: _withCtx(() => [
        (canRequestExceptionality.value && _ctx.stationContext?.team !== 'Externo')
          ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
              _createVNode(FilledButton, {
                text: "Nova solicitação",
                width: "100%",
                class: "!bg-primary30 mt-6",
                "data-testid": "exceptionalities-sidebar-new-request-button",
                disabled: _ctx.postStationLocked,
                onClick: handleRequestNew
              }, null, 8, ["disabled"]),
              (_ctx.postStationLocked)
                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                    key: 0,
                    activator: "parent",
                    location: "top",
                    text: _unref(POST_STATION_LOCK_BANNER_TEXT)
                  }, null, 8, ["text"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                color: "primary",
                size: "64"
              })
            ]))
          : (!exceptionalities.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
            : _createCommentVNode("", true),
        (exceptionalities.value.length > 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(exceptionalities.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: "bg-white rounded-lg border border-gray-300 p-4 mb-4"
              }, [
                _createElementVNode("p", _hoisted_5, "Pedido #" + _toDisplayString(item.id), 1),
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", null, [
                    _hoisted_8,
                    _createElementVNode("p", null, _toDisplayString(item.requester.name), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_9,
                    _createElementVNode("p", null, _toDisplayString(_unref(formatDateToString)(new Date(item.requestDate))), 1)
                  ]),
                  (item.evaluator)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _hoisted_11,
                        _createElementVNode("p", null, _toDisplayString(item.evaluator.name), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (item.evaluationDate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _hoisted_13,
                        _createElementVNode("p", null, _toDisplayString(_unref(formatDateToString)(new Date(item.evaluationDate))), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (timelinePropsMap.value.get(item.id))
                  ? (_openBlock(), _createBlock(ExceptionalityProgressTimeline, _mergeProps({ key: 0 }, timelinePropsMap.value.get(item.id)!, {
                      class: "my-3",
                      "default-expanded": false,
                      "data-testid": "exceptionalities-sidebar-progress-timeline"
                    }), null, 16))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(StatusBadge, {
                      status: item.status
                    }, null, 8, ["status"]),
                    (_unref(isReversalPending)(item, _unref(flags).enabledApprovalEngine))
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "inline-flex items-center rounded-full border border-warning bg-warning/20 px-2 py-0.5 text-xs font-bold text-yellow-800",
                          "data-testid": `exceptionalities-sidebar-reversal-pending-${item.id}`
                        }, " Reversão pendente ", 8, _hoisted_16))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(OutlineButton, {
                    text: "Ver pedido",
                    height: "32px",
                    width: "auto",
                    class: "!text-sm !px-3",
                    "data-testid": `exceptionalities-sidebar-view-request-button-${item.id}`,
                    onClick: ($event: any) => (handleViewRequest(item))
                  }, null, 8, ["data-testid", "onClick"])
                ])
              ]))
            }), 128))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (_ctx.stationContext)
        ? {
            name: "contextHeader",
            fn: _withCtx(() => [
              _createVNode(StationContextCard, _normalizeProps(_guardReactiveProps(_ctx.stationContext)), null, 16)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue", "icon"]),
    _withDirectives(_createVNode(SummaryExceptionalitySidebar, {
      "is-open": isActionSidebarOpen.value,
      "exception-id": exceptionIdSelected.value,
      "action-type": currentActionType.value,
      scheduleId: props.scheduleId,
      "station-context": _ctx.stationContext,
      "post-station-locked": _ctx.postStationLocked,
      "onUpdate:isOpen": _cache[1] || (_cache[1] = ($event: any) => (isActionSidebarOpen.value = $event)),
      onActionCompleted: handleActionCompletedGeneric
    }, null, 8, ["is-open", "exception-id", "action-type", "scheduleId", "station-context", "post-station-locked"]), [
      [_vShow, isActionSidebarOpen.value]
    ]),
    (isReversalSidebarOpen.value && exceptionIdSelected.value && props.scheduleId)
      ? (_openBlock(), _createBlock(RequestExceptionalitySidebar, {
          key: 0,
          "is-open": isReversalSidebarOpen.value,
          "onUpdate:isOpen": _cache[2] || (_cache[2] = ($event: any) => ((isReversalSidebarOpen).value = $event)),
          mode: "REVERSAL",
          "exception-id": exceptionIdSelected.value,
          "schedule-id": props.scheduleId,
          "station-context": _ctx.stationContext,
          "post-station-locked": _ctx.postStationLocked,
          onSubmitSuccess: handleActionCompletedGeneric
        }, null, 8, ["is-open", "exception-id", "schedule-id", "station-context", "post-station-locked"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})